// ClientDataContext.js
import React, { createContext, useContext, useState } from 'react';

const ClientDataContext = createContext(null);

export const ClientDataProvider = ({ children }) => {
    const [clientData, setClientData] = useState(null);

    return (
        <ClientDataContext.Provider value={{ clientData, setClientData }}>
            {children}
        </ClientDataContext.Provider>
    );
};

export const useClientData = () => {
    const context = useContext(ClientDataContext);
    if (!context) {
        throw new Error('useClientData must be used within a ClientDataProvider');
    }
    return context;
};
